import { useRef } from 'react'
import { AxiosError } from 'axios'
import { useInfiniteQuery } from '@tanstack/react-query'

import { Queries } from 'api/queries.enum'
import {
    GetPulseSurveyFreeTextResultsParams,
    GetPulseSurveyFreeTextResultsResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { getPulseSurveyFreeTextResult } from 'api/actions/pulseSurveys/pulseSurveysActions'

export const useGetSingleFreeTextInfinite = (params: GetPulseSurveyFreeTextResultsParams) => {
    const queryInitialPage = useRef(params?.page || 1)
    const pageSize = useRef(params?.page_size || 10)

    const query = useInfiniteQuery<GetPulseSurveyFreeTextResultsResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveyFreeTextResult, params.surveyUUID, params.freeTextQuestionUUID],
        queryFn: ({ pageParam = queryInitialPage.current }) =>
            getPulseSurveyFreeTextResult({
                ...params,
                page: pageParam,
                page_size: pageSize.current,
            }),
        getNextPageParam: ({ page }) => page + 1,
        keepPreviousData: true,
        ...preventRefetchQueryOptions,
    })

    return query
}
